import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { AuthGuard } from './auth.guard';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { MyspaceComponent } from './myspace/myspace.component';
import { BeverageComponent } from './beverage/beverage.component';
import { MenuComponent } from './menu/menu.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'myspice', component: MyspaceComponent },
  { path: 'login', component: LoginComponent },
  { path: 'beverage', component: BeverageComponent },
  { path: 'menu', component: MenuComponent },
  // { path: 'reservations/:dateId', component: CustomerReservationsComponent },
  // { path: 'reservations', component: CustomerReservationsComponent, canActivate: [ReservationGuard] }
  { path: 'admin', component: AdminComponent, canActivate: [AuthGuard]}
  // { path: 'admin', component: AdminComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
